import React, { useEffect, useState } from "react";
import arrowLeft from "../../assets/images/arrow-leftttttt.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { sponsorService } from "services/sponsor.service";
import useCurrentUser from "hooks/useCurrentUser";
import { paymnetService } from "services/payment.service";
import { toast } from "react-toastify";

const AdvertisementAlert = () => {
  const { id } = useParams()
  const [data, setData] = useState('')
  const navigate = useNavigate();
  const { user } = useCurrentUser()
  const getsponserRequesterDetails = async () => {
    try {
      const response = await sponsorService.sponsorRequestDetails(id)
      setData(response?.data?.data)
    }
    catch (err) {
      console.log(err?.response?.data)
    }
  }

  const handlePayNow = async (sponser) => {
    try {
      const response = await paymnetService.createCheckoutSession({ type: 'SponsorRequest', id: sponser?._id });
      response?.data?.data?.url && window.open(response?.data?.data?.url, '_blank');
    } catch (err) {
      toast.error(err.data.message);
    }
  }

  useEffect(() => {
    getsponserRequesterDetails();
  }, [])

  const handleBack = () => {
    navigate(-1);
  }

  return (
    <div>
      <div className="container-box">
        <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white ">
          <h2>
            <img src={arrowLeft} className="me-3 cursor-pointer" onClick={handleBack} alt="" />Advertisement
          </h2>
        </div>

        <div className="outer-white pt-2">
          <div className="disaster-alert">
            <div className="alert-container">
              <div className="row gap-2">
                <div className="alert-column-1 text-center text-md-start p-3 text-center d-flex flex-column align-items-center bg-card-gray rounded-3">
                  <div className="alert-icon mx-auto mx-md-0">
                    {data?.banner ? (
                      <img src={`${user?.baseS3Url}${data?.banner}`} alt="Advertisement banner icon" />
                    ) : null}
                  </div>
                  <div className="alert-meta mt-2 text-center">
                    <div><strong>Name:</strong> {data?.fullName || '-'} </div>
                    <div><strong>Email:</strong> {data?.email || '-'}</div>
                    <div><strong>Phone:</strong> {data?.phone || '-'}</div>
                    {data?.paymentStatus ? (
                      <div><strong>Payment Status:</strong> {data?.paymentStatus}</div>
                    ) : null}
                  </div>
                </div>

                <div className="alert-column-2 bg-card-gray rounded-3 p-4">
                  <h2 className="alert-title">Advertisement!</h2>
                  {data?.link ? (
                    <div className="mb-2"><strong>Link: </strong>
                      <Link to={data?.link} className="pb-3" target="_blank">{data?.link}</Link>
                    </div>
                  ) : null}
                  <p className="alert-description">{data?.description}</p>
                  {data?.banner ? (
                    <div className="mt-3">
                      <img src={`${user?.baseS3Url}${data?.banner}`} alt="Advertisement banner" className="w-100 rounded-3" />
                    </div>
                  ) : null}

                  {data?.userId === user?._id ? (
                    <>
                      {data?.paymentStatus === "Paid" ? (
                        <div className="mt-3">Payment Status: Paid</div>
                      ) : data?.paymentStatus === "UserDeny" ? (
                        <div className="mt-3">Payment Status: Denied</div>
                      ) : data?.isChargeRequestedByAdmin === true ? (
                        <div className="d-flex gap-2 mt-3">
                          <button
                            className="btn pay-btn blue-btn" onClick={() => handlePayNow(data)}>
                            Pay Now
                          </button>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementAlert;
